<div class="page">
  <div class="forgot-password-container">
    <div class="logo-section">
      <img src="{{ BASE_URL }}/web/binary/company_logo" alt="company's logo" />
      <span>{{ 'authentication.b2b_portal' | translate }}</span>
    </div>

    <form class="email-form" [formGroup]="resetPasswordForm">
      <h2 class="title">{{ 'authentication.reset_password' | translate }}</h2>

      <ui-form-field
        [fullWidth]="true"
        formControlName="email"
        [label]="'authentication.email' | translate"
        [placeholder]="'authentication.email_placeholder' | translate"
        [type]="'text'"
        [errorMessages]="{
          required: 'validation.required' | translate,
          invalidEmail: 'validation.invalid_email' | translate
        }"
      ></ui-form-field>

      <ui-button
        type="primary"
        [label]="'quotes_and_order.status_dialog.actions.request_reset_link' | translate"
        [fullWidth]="true"
        (click)="requestPasswordReset()"
      ></ui-button>

      <span class="go-to-login">
        <a routerLink="/">{{ 'authentication.back_to_login' | translate }}</a>
      </span>
    </form>

    <div class="copyright-section">
      <div class="powered-by">
        <span>{{ 'common.powered_by' | translate }}</span>
        <img class="logo" src="assets/images/logo.svg" alt="volta logo" />
      </div>
      <p>{{ 'authentication.terms_ack' | translate }}</p>
      <div class="links">
        <span
          [innerHTML]="'authentication.rights_reserved' | translate: { year: currentYear }"
        ></span>
        <a href="#">{{ 'common.privacy_policy' | translate }}</a>
        <a href="#">{{ 'common.support' | translate }}</a>
      </div>
    </div>
  </div>
</div>
